import { render, staticRenderFns } from "./jinxian.vue?vue&type=template&id=179218ae&scoped=true&"
import script from "./jinxian.vue?vue&type=script&lang=js&"
export * from "./jinxian.vue?vue&type=script&lang=js&"
import style0 from "./jinxian.vue?vue&type=style&index=0&id=179218ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179218ae",
  null
  
)

export default component.exports